<template>
  <v-container fluid class="investfund-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/investfund/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="investfunds-table"
              show-select
              single-select
              item-key="_id"
              sort-by="fundrank"
              :footer-props="footer"
              :headers="headers"
              :items="funds"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Fund?
                    </v-card-title>

                    <v-card-text>
                      {{ delete_fund.fundname }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(delete_fund)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.fundimage="{ item }">
                    <v-img
                    v-if="item.fundimage" 
                    v-bind:src="item.fundimage"
                    max-height="80"
                    max-width="80"
                  ></v-img>
              </template>
              <template v-slot:item.fundname="{ item }">
                <p class="two-line"><a class="primaryConst--text">{{ item.investfundcode }}</a></p>
                <p class="two-line"><a class="primaryConst--text">{{ item.fundname }}</a></p>
                <p class="two-line">{{ item.investfundinfo }}</p>
              </template>
              <template v-slot:item.fundstatus="{ item }">
                <v-chip
                  :color="getStatusColor(item.fundstatus)"
                  small>
                  {{ item.fundstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-US", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../config";
import { mapState, mapActions } from 'vuex';
import { getStatusColor } from '../../../util/tools';

export default {
  name: 'investfundList',
  data() {
    return {
      config,
      snackbar: null,
      dialog: false,
      delete_fund: {},
      headers: [
        { text: 'Image', value: 'fundimage', sortable: false, width: '10%' },
        { text: 'Rank', value: 'fundrank', width: '5%'},
        { text: 'Type', value: 'fundtype', width: '20%'  },
        { text: 'Name', value: 'fundname' },
        { text: 'Status', value: 'fundstatus', width: '10%'  },
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 100,
      selected: [],
      getStatusColor: getStatusColor,
    }
  },
  computed: {
    ...mapState('InvestFund', ['funds', 'isReceiving', 'isDeleting', 'idToDelete', 'fundsMessage', 'isUpdating']),
  },
  methods: {
    ...mapActions('InvestFund', ["getInvestFundsRequest","deleteInvestFundRequest","updateInvestFundRequest","createInvestFundRequest"
    ]),
    editItem(item) {
      this.$router.push({ name: 'InvestFundEdit', params: item })
    },
    deleteItem(item) {
      this.deleteInvestFundRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.delete_fund = {
        _id: item._id,
        fundname: item.fundname,
      }
    },
  },
  async created () {
    await this.getInvestFundsRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
